module.exports = __webpack_public_path__ + "static/media/logo.878f574d.png";